import { render } from "./SearchGoods.vue?vue&type=template&id=4c621b40&scoped=true"
import script from "./SearchGoods.vue?vue&type=script&lang=js"
export * from "./SearchGoods.vue?vue&type=script&lang=js"

import "./SearchGoods.vue?vue&type=style&index=0&id=4c621b40&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c621b40"]])

export default __exports__